import React from 'react';
import { STATES } from '../config/constants/contractStates';
import 'antd/dist/antd.css';
import PropTypes from 'prop-types';

const StatusBadge = ({ status }) => {
  switch (status) {
    case STATES.CREATED:
      return (<span className="badge badge-primary mb-2">Pagado</span>);
    case STATES.AWAITING_VALIDATION:
      return (<span className="badge badge-success mb-2">Esperando validación</span>);
    case STATES.VALIDATE_BY_ALL:
      return (<span className="badge badge-success mb-2">Validado</span>);
    case STATES.AWAITING_SIGN:
      return (<span className="badge badge-purple mb-2">Esperando firmas</span>);
    case STATES.SENDED:
    case STATES.AWAITING_NOTARY:
      return (<span className="badge badge-warning mb-2">Notarisa</span>);
    case STATES.APPEALED:
      return (<span className="badge badge-warning mb-2">Esperando evidencias</span>);
    case STATES.OBJECTED:
      return (<span className="badge badge-danger mb-2">Objetado</span>);
    case STATES.FINALIZED:
      return (<span className="badge badge-light mb-2">Finalizado</span>);
    case STATES.CANCELED:
      return (<span className="badge badge-light mb-2">Anulado</span>);
    case STATES.HALT:
      return (<span className="badge badge-danger mb-2">Detenido</span>);
    case STATES.DRAFT:
      return (<span className="badge badge-danger mb-2">Borrador</span>);
    default:
      return (<></>);
  };
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusBadge;